import React, { useState, useEffect, useContext, useMemo } from "react";
import "./Assests/Scss/TeacherDiifLevel.scss";
import InternetChecking from "../Student/Reusablecomponents/Network";
import {
  SUbjects,
  Section,
  AssessmentName,
} from "../Student/Reusablecomponents/RegularFunctions";
import { FaAnglesRight, FaAnglesLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axiosInstance from "../ReusableComponents/Axios";
import ReuseTable from "../ReusableComponents/Table";
import { LoadContext } from "../ReusableComponents/LoadingContex";
import { ExportXlButton } from "../ReusableComponents/CommonComponents";
import { DownloadExcel } from "../ReusableComponents/CommonFunctions";
import DropdownValues from "../Student/Reusablecomponents/DropDownValues";
import { InstituteGrades } from "../ReusableComponents/CommonApis";
const TeachDiffLevel = () => {
  const navigate = useNavigate();
  const { SetLoad } = useContext(LoadContext);
  const Filters = JSON.parse(localStorage.getItem("DiFFInput"));
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);

  const [GetGrade, SetGetGrade] = useState(Filters?.Grade);
  const [GetSection, SetGetSection] = useState(Filters?.Section);
  const [GetSubject, SetGetSubject] = useState(Filters?.Subject);
  const [DiffList, SetDiffList] = useState();
  const GetTeacherDifflevelList = async () => {
    SetLoad((prev) => !prev);
    try {
      const res = await axiosInstance.get(
        `/Principal/GetSchoolAssessmentWiseLOAndDifficultyDetails?ContestCreationId=${SelectDate?.value}&SubjectName=${GetSubject}&SchoolId=${items.schoolId}&Grade=${GetGrade}&Section=${GetSection}&AssessmentType=${SelectDate?.assessmentType}`,
      );
      SetDiffList(res.data);
      SetLoad((prev) => !prev);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (SelectDate?.value > 0 && GetSubject && GetGrade) {
      GetTeacherDifflevelList();
    } else {
      SetDiffList();
    }
  }, [GetGrade, SelectDate?.value, GetSection, GetSubject]);

  const GetColor = (e) => {
    switch (true) {
      case e <= 40:
        return "#fb5f6e";
      case e > 40 && e <= 80:
        return "#f6be61";
      case e > 80:
        return "#7dde98";
      default:
        return " ";
    }
  };
  const Eachstudentnavigation = (Pagename) => {
    const data = {
      Subject: GetSubject,
      Section: GetSection,
      Grade: GetGrade,
      SubjectsList: Filters?.SubjectsList,
      SectionsList: Filters?.SectionsList,
    };
    if (Pagename === "DPerformance") {
      window.open("/TeacherDashboard/PerformanceByeachSubject", "_blank");
    } else {
      // navigate("/TeacherDashboard", { replace: true });
      window.close();
    }
    localStorage.setItem("DiFFInput", JSON.stringify(data));
  };

  const Diffcolumns = [
    { name: "Difficulty Level", selector: "difficultyLevel", filterable: true },
    {
      name: "% Correct",
      selector: "percentage",
      filterable: true,
      cell: (row) => (
        <div
          className="p-0"
          style={{ backgroundColor: GetColor(row.percentage), color: "#FFF" }}
        >
          {" "}
          {row.percentage}
        </div>
      ),
    },
    {
      name: "learning outcomes",
      selector: "lo",
      filterable: true,
      cell: (row) => <div style={{ textAlign: "justify" }}> {row.lo}</div>,
    },
  ];

  const DownloadXl = () => {
    const XL = DiffList?.map((item, index) => {
      return {
        SNo: index + 1,
        "Difficulty level": item.difficultyLevel,
        "% Correct": item.percentage,
        "learning outcomes": item.lo,
      };
    });
    DownloadExcel(
      XL,
      `Performance by difficulty level - ${AssessmentName(SelectDate?.assessmentType)} - ${SelectDate?.examStartDate}`,
      false,
      `Performance by difficulty level - ${AssessmentName(SelectDate?.assessmentType)} - ${SelectDate?.examStartDate}`,
      `Performance by difficulty level - ${AssessmentName(SelectDate?.assessmentType)} - ${SelectDate?.examStartDate}`,
      true,
    );
  };
  const [ASSGrade, SetAssGrade] = useState();
  const GetAssmentdates = async () => {
    const Data = await InstituteGrades(
      items?.instituteId,
      SelectDate,
      USYear?.value,
      items?.userId,
    );
    const Grades = Data?.[0]?.grade?.split(",");
    SetAssGrade(
      Grades?.map((grade) => ({
        display: `Grade ${grade}`,
        value: grade.trim(),
      })),
    );
    SetGetGrade(Filters?.Grade || Grades?.[0]);
  };
  useMemo(() => {
    if (SelectDate) {
      GetAssmentdates();
    }
  }, [SelectDate]);
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="dflex JSBetween">
          <button
            className="Buttons"
            onClick={() => Eachstudentnavigation("Dashboard")}
          >
            <FaAnglesLeft /> Back to dashboard{" "}
          </button>

          <button
            className="Buttons"
            onClick={() => Eachstudentnavigation("DPerformance")}
          >
            Detailed performance of student <FaAnglesRight />{" "}
          </button>
        </div>
        <div className="MainHeading">
          Performance by difficulty level -{" "}
          {AssessmentName(SelectDate?.assessmentType)} -{" "}
          {SelectDate?.examStartDate}
        </div>
        <div className=" dflex JSBetween alignitems mt-2 TDLTitle">
          <div></div>
          <div className=" dflex alignitems" style={{ gap: "10px" }}>
            {SelectDate?.value > 0 && (
              <>
                <DropdownValues
                  className="NCLDropdown"
                  options={ASSGrade}
                  selectoption={GetGrade}
                  Displayname="Select Grade"
                  onChange={(e) => SetGetGrade(e.target.value)}
                />
                {GetGrade > 0 && (
                  <>
                    <Section
                      className="NCLDropdown"
                      Postsection={SetGetSection}
                      selected={"Section " + GetSection}
                      Options={Filters?.SectionsList}
                    />
                    {GetSection !== -1 && (
                      <SUbjects
                        className="NCLDropdown"
                        Postsubject={SetGetSubject}
                        selected={GetSubject}
                        Options={Filters?.SubjectsList}
                      />
                    )}{" "}
                    {DiffList?.[0].difficultyLevel && (
                      <ExportXlButton
                        Name="Export to Excel"
                        Click={() => DownloadXl()}
                      />
                    )}
                  </>
                )}{" "}
              </>
            )}
          </div>
        </div>
        <div className="Card mt-3">
          <div className="Table-Legends dflex  ">
            <div className="dflex" style={{ gap: "20px" }}>
              <span>0 - 40%</span>
              <span>41 - 80%</span>
              <span>81 - 100%</span>
            </div>
          </div>
          <ReuseTable
            className="NCLDataTable mt-3"
            data={DiffList?.[0].difficultyLevel && DiffList}
            columns={Diffcolumns}
          />
        </div>
      </div>
    </>
  );
};
export default TeachDiffLevel;
